import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

import { AppSharedUIModule } from 'app-shared-ui';
import { TranslocoRootModule } from 'app-core';

import { AuthGuard } from '../guards/auth.guard';
import { ReferralComponent } from './referral/referral.component';
import { MedicalRepresentativesComponent } from './medical-representatives/medical-representatives.component';
import { ManageReferralsComponent } from './manage-referral/manage-referral.component';
import { ProductPresentationUsersComponent } from './product-presentation-users/product-presentation-users.component';
import { ProductPresentationDoctorsComponent } from './product-presentation-doctors/product-presentation-doctors.component';
import { ProductPresentationSalesComponent } from './product-presentation-sales/product-presentation-sales.component';
import { WebsitesComponent } from './websites/websites.component';
import { DummyDataDoctorsAppointmentComponent } from './dummy-data/doctor/appointments/appointments.component';
import { DummyDataDoctorsComponent } from './dummy-data/doctor/doctors/doctors.component';
import { DummyDataUsersComponent } from './dummy-data/users/users.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductPresentationScanComponent } from './product-presentation-scan/product-presentation-scan.component';
import { DummyDataBodyScanHomeComponent } from './dummy-data/body-scan/dummy-data-body-scan.component';
import { DummyDataHomeComponent } from './dummy-data/dummy-data-home.component';
import { DummyDataDoctorsHomeComponent } from './dummy-data/doctor/dummy-data-doctors.component';
import { DummyDataBodyScanComponent } from './dummy-data/body-scan/doctors/doctors.component';
import { DummyDataScanAppointmentComponent } from './dummy-data/body-scan/appointments/appointments.component';
import { DummyDataCouponsComponent } from './dummy-data/doctor/coupons/coupons.component';
import { DummyDataMedicinesComponent } from './dummy-data/doctor/medicines/medicines.component';

@NgModule({
  declarations: [
    DummyDataHomeComponent,
    DummyDataBodyScanHomeComponent,
    DummyDataCouponsComponent,
    DummyDataDoctorsComponent,
    DummyDataDoctorsHomeComponent,
    DummyDataBodyScanComponent,
    DummyDataDoctorsAppointmentComponent,
    DummyDataMedicinesComponent,
    DummyDataScanAppointmentComponent,
    DummyDataUsersComponent,
    MedicalRepresentativesComponent,
    ManageReferralsComponent,
    ProductPresentationDoctorsComponent,
    ProductPresentationScanComponent,
    ProductPresentationSalesComponent,
    ProductPresentationUsersComponent,
    ReferralComponent,
    WebsitesComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    AppSharedUIModule,
    CommonModule,
    RouterModule.forChild([
      {
        path: 'manage/referral',
        component: ReferralComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/referrals',
        component: ManageReferralsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/sales',
        component: MedicalRepresentativesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/product/presentation/users',
        component: ProductPresentationUsersComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/product/presentation/doctors',
        component: ProductPresentationDoctorsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/product/presentation/scan',
        component: ProductPresentationScanComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/product/presentation/sales',
        component: ProductPresentationSalesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/websites',
        component: WebsitesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/dummy-data',
        component: DummyDataHomeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/dummy-data/doctors/medicines',
        component: DummyDataDoctorsHomeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/dummy-data/doctors/coupons',
        component: DummyDataDoctorsHomeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/dummy-data/doctors/appointments',
        component: DummyDataDoctorsHomeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/dummy-data/doctors/doctors',
        component: DummyDataDoctorsHomeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/dummy-data/doctors/users',
        component: DummyDataDoctorsHomeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/dummy-data/scan/appointments',
        component: DummyDataBodyScanHomeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/dummy-data/scan/doctors',
        component: DummyDataBodyScanHomeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage/dummy-data/scan/users',
        component: DummyDataBodyScanHomeComponent,
        canActivate: [AuthGuard],
      },
    ]),
    MatDividerModule,
    NgxDocViewerModule,
    TranslocoRootModule,
  ],
  providers: [],
})
export class OrganizationModule {}
